import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import $ from 'jquery';
import Controller from '@ember/controller';
import {
  SELLER_PROFILE_PROJECT_LIST_CLASS,
  SELLER_PROFILE_SCROLL_TO_MORE_PROJECTS_IN_MS,
} from '../constants/components/profile';
import { STORAGE_KEYS } from '../services/local-storage-fallback';
import { EMBER_ROUTE_NAMES } from '../constants/routes';

class ProfileController extends Controller {

  @service router;
  @service session;

  /** @inheritDoc */
  queryParams = ['project'];

  /** @type {User} */
  @readOnly('model.user')
  user;

  /** @type {String} The ID of the project to feature. */
  project = null;

  /** @type {Boolean|null} If true, seller profile will navigate directly to blocked section. */
  blockedDetails = null;

  /** @type {Ember.Component} The reference to the child profile component. */
  _profileRef = null;

  /**
   * Checks whether it is safe to transition away from the profile.
   */
   canTransitionAway() {
    const profileRef = this._profileRef;

    if (!profileRef) return true;

    return profileRef.canTransitionAway;
  }

  /**
   * Runs cleanup on the child profile component.
   */
  runProfileCleanup() {
    const profileRef = this._profileRef;

    if (!profileRef) return;

    return profileRef.cleanup();
  }

  /** Scrolls to the project digests. */
  @action
  handleOnMoreDigestsClicked() {
    const sellerProjectListEl = $(`.${SELLER_PROFILE_PROJECT_LIST_CLASS}`);

    $([document.documentElement, document.body]).animate({
      scrollTop: sellerProjectListEl.offset().top - 70
    }, SELLER_PROFILE_SCROLL_TO_MORE_PROJECTS_IN_MS);
  }

  /** Saves the desired profile in storage and transitions to login. */
  @action
  onLoginToViewClicked() {
    this.get('storage').setItem(
      STORAGE_KEYS.UNAUTHED_PROFILE_SLUG_TO_VIEW,
      this.get('user.slug'),
    );
    this.get('router').transitionTo(EMBER_ROUTE_NAMES.SIGNIN);
  }

  /**
   * @param {string|null} projectID
   *
   * Handles updates to the project query parameter.
   */
  @action
  handleProjectParamUpdate(projectID) {
    this.set('project', projectID || null);
  }

  /**
   * Called when the child profile component initializes.
   *
   * @param {Ember.Component} profile
   */
  @action
  handleSetProfileRef(profile) {
    this.set('_profileRef', profile);
  }
}

export default ProfileController;
